import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const hasSubscriptionAccess = (user) => {
  if (!user) return false;
  if (user.isSubscribed) return true;
  if (!user.currentPeriodEnd) return false;

  const periodEnd = new Date(user.currentPeriodEnd);
  if (Number.isNaN(periodEnd.getTime())) return false;
  return periodEnd.getTime() > Date.now();
};

const ProtectedRoutes = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const subscriptionAllowedPaths = [
    "/pricing",
    "/subscription/success",
    "/subscription/cancel",
    "/user/settings",
  ];

  if (
    user.role === "user" &&
    !hasSubscriptionAccess(user) &&
    !subscriptionAllowedPaths.includes(location.pathname)
  ) {
    return <Navigate to="/pricing" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
